import { Overlay as DialogOverlay, DialogOverlayProps } from '@radix-ui/react-dialog';
import { twMerge } from 'tailwind-merge';

import styles from './styles.module.css';

export const Overlay = ({
  className,
  children,
  ...props
}: DialogOverlayProps & React.RefAttributes<HTMLDivElement>) => {
  return (
    <DialogOverlay
      className={twMerge(
        'bg-special-background-overlay',
        'flex',
        'fixed',
        'w-full',
        'h-full',
        'z-1000',
        'flex-col',
        'left-0',
        'top-0',
        'backdrop-blur-3px',
        styles.animatedOverlay,
        className,
      )}
      {...props}
    >
      {children}
    </DialogOverlay>
  );
};
